import { fill } from './fill.js'
import { KindergartenInitial2016 as Page } from './Page.jsx'
import templateUrl from './template.pdf'

export default {
  key: 'kindergarten_initial_2016_06',
  label: 'Kindergarten Communication of Learning — Initial Observations',
  templateUrl,
  fill,
  Page,
}
